import React  from 'react';
const jobImage = (props) => {
	return(
		<div className="job-img-box">
			<img src={props.imgSrc} alt=""/>
		</div>
	)
};
export default jobImage;